import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/home.vue'
import BigPicture from '../components/BigPicture.vue'
import CulturalProducts from '../components/CulturalProducts.vue'
import Application from '../components/Application.vue'
import BusinessCooperation from '../components/BusinessCooperation.vue'
import TalentRecruitment from '../components/TalentRecruitment.vue'
import ApplicationIntro from '../components/ApplicationIntro.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component:Home
    },
    {
      path: '/BigPicture',
      name: 'BigPicture',
      component: BigPicture
    },
    {
      path: '/CulturalProducts',
      name: 'CulturalProducts',
      component:CulturalProducts
    },
    {
      path: '/Application',
      name: 'Application',
      component: Application
    },
    {
      path: '/BusinessCooperation',
      name: 'BusinessCooperation',
      component: BusinessCooperation
    },
    {
      path: '/TalentRecruitment',
      name: 'TalentRecruitment',
      component: TalentRecruitment
    },
    {
      path: '/ApplicationIntro',
      name: 'ApplicationIntro',
      component: ApplicationIntro
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js